import { render, staticRenderFns } from "./Trucker.vue?vue&type=template&id=dc6bcd5a&"
import script from "./Trucker.vue?vue&type=script&lang=js&"
export * from "./Trucker.vue?vue&type=script&lang=js&"
import style0 from "./Trucker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports